import { useState, useEffect } from 'react';
import { ILoginLog, IAuditLog, IRequestLogs } from 'src/share/types/audit';
import { ISearch } from 'src/share/types/search';
import { timestampToDateTimeStringShort, momentToMiliseconds } from 'src/share/utils/utils';
import useDidUpdateEffect from 'src/share/hooks/useDidUpdateEffect';
import { IDateRange } from 'src/share/hooks/useDateRangeFilter';
import { AuditService } from 'src/share/services/audit';

type LogsData = [ILoginLog[] | IAuditLog[], number, boolean];

function useLogs(search: ISearch, dateRange: IDateRange, logsType): LogsData {
  const [logs, setLogs] = useState<ILoginLog[] | IAuditLog[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  function transformData(record, index) {
    return { 
      ...record, 
      id: `${index}-${record.id}`,
      date: timestampToDateTimeStringShort(record.date),
      entityID: record.id
    }
  }
  function transformRange() {
    const { startDate, endDate } = dateRange;
    const isComplete = startDate && endDate
    return !isComplete && !dateRange.focus ? null : {
      date: {
        gte: momentToMiliseconds(startDate),
        lte: momentToMiliseconds(endDate)
      }
    }
  }
  async function fetchData(): Promise<void>{
    setIsLoading(true);
    const requestOptions: IRequestLogs = {
      sort: search.sort,
      size: search.size,
      page: search.page,
      search: search.queryString,
      range: transformRange()
    }
    const response = await AuditService.getAuditLogs(requestOptions, logsType);
    const transformedData = response.results.map(transformData);
    setTotal(response.total);
    setLogs(transformedData);
    setIsLoading(false);
  }
  useEffect(() => {
    fetchData();
  }, [search]); 
  useDidUpdateEffect(() => {
    if (dateRange.startDate && dateRange.endDate && !dateRange.focus) {
      fetchData();
    }
  }, [dateRange.focus]);
  return [logs, total, isLoading]
}

export default useLogs;